import axios from "axios";

export const BACKEND_URL = "https://api.shiftquote.app";
export const API = `${BACKEND_URL}/api`;

// Detect Capacitor native shell (WebView origin is https://localhost or
// capacitor://localhost — different from the API origin, so the request
// becomes cross-origin). The Kubernetes ingress responds to preflights with
// `Access-Control-Allow-Origin: *`, which browsers refuse to combine with
// credentials. Native apps use Bearer-token auth (set by interceptor below),
// so we can safely disable cookie credentials when running inside Capacitor.
const isNativeApp =
  typeof window !== "undefined" &&
  (!!window.Capacitor?.isNativePlatform?.() ||
    window.location.protocol === "capacitor:" ||
    window.location.hostname === "localhost");

export const api = axios.create({
  baseURL: API,
  withCredentials: !isNativeApp,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// shop-status-access-nov2: the backend re-checks a shop's status on every
// request. When it answers 403 with one of the shop-status notices (account
// suspended / application not approved), tell AuthContext to re-read
// /auth/me so the route guard moves the shop to the notice screen at once.
export const SHOP_STATUS_EVENT = "shiftquote:shop-status-changed";
const SHOP_STATUS_PREFIXES = [
  "Your shop account is suspended",
  "Your shop application was not approved",
];
api.interceptors.response.use(
  (res) => res,
  (error) => {
    try {
      const detail = error?.response?.data?.detail;
      if (
        error?.response?.status === 403 &&
        typeof detail === "string" &&
        SHOP_STATUS_PREFIXES.some((p) => detail.startsWith(p)) &&
        typeof window !== "undefined"
      ) {
        window.dispatchEvent(new CustomEvent(SHOP_STATUS_EVENT));
      }
    } catch (_) { /* never block the original error */ }
    return Promise.reject(error);
  }
);

export const authFileUrl = (storagePath) => {
  const token = localStorage.getItem("auth_token") || "";
  return `${API}/files/${storagePath}?auth=${encodeURIComponent(token)}`;
};
